import { isSSR } from './ssr.utilities'

export const freshpaint = () => {
  if (isSSR()) return

  if (!window.freshpaint) return

  return window.freshpaint
}
